<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-12 col-xs-12">
        <h1>Vertical Center in CSS</h1>
      </div>
      <div class="col-lg-8 col-md-12 col-xs-12 text-right">
        <!-- /1046442/cssvc -->
        <div id='div-gpt-ad-1552469456433-0' style='height:90px; width:728px;'>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12" id="ad1_vue" ref="vue_ad1">
        <div v-if="showAd1">
          <iframe v-if="isMobile" data-aa='1999276' src='//ad.a-ads.com/1999276?size=320x50' style='width:320px; height:50px; border:0px; padding:0; overflow:hidden; background-color: transparent;'></iframe>
          <iframe v-else data-aa='1999233' src='//ad.a-ads.com/1999233?size=728x90' style='width:728px; height:90px; border:0px; padding:0; overflow:hidden; background-color: transparent;'></iframe>
        </div>
      </div>
      <div class="col-xs-12">
        <h2>Solution 1: Flexbox</h2>
      </div>
      <div class="col-xs-12" v-highlight>
        <pre class="pre-padding">
        <code class="language-html">
        {{verticalFlexHtml}}
        </code>
        <code  class="language-css">
        .wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          /* add code below to also center horizontally */
          align-items: center;
        }
        </code>
        </pre>
      </div>
      <div class="col-xs-12">
        <h3>Compatibility:</h3>
        <div class="caniuse">
          <p class="ciu_embed" data-feature="flexbox" data-periods="future_1,current,past_1,past_2" data-accessible-colours="false">
          <a href="http://caniuse.com/#feat=flexbox"></a>
          </p>
        </div>
      </div>
    </div>
    <div class="row mt20">
      <div class="col-xs-12">
        <h2>Solution 2: top / transformY</h2>
      </div>
      <div class="col-xs-12" v-highlight>
        <pre class="pre-padding">
        <code class="language-html">
        {{verticalTransformHtml}}
        </code>
        <code  class="language-css">
        .wrapper {
          position: relative;
        }
        .centered {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          /* add code below to also center horizontally */
          left:0;
          right:0;
          margin: 0 auto;
        }
        </code>
        </pre>
      </div>
      <div class="col-xs-12">
        <h3>Compatibility:</h3>
        <div class="caniuse">
          <p class="ciu_embed" data-feature="transforms2d" data-periods="future_1,current,past_1,past_2" data-accessible-colours="false">
          </p>
        </div>
      </div>
    </div>
    <div class="row mt20">
      <div class="col-xs-12">
        <h2>Solution 3: display table</h2>
      </div>
      <div class="col-xs-12" v-highlight>
        <pre class="pre-padding">
        <code class="language-html">
        {{verticalTableHtml}}
        </code>
        <code  class="language-css">
        .wrapper {
          display:table
        }
        .centered {
          display:table-cell;
          vertical-align:middle;
          /* add code below to also center horizontally */
          text-align:center;
        }
        </code>
        </pre>
      </div>
      <div class="col-xs-12">
        <h3>Compatibility:</h3>
        <div class="caniuse">
          <p class="ciu_embed" data-feature="css-table" data-periods="future_1,current,past_1,past_2" data-accessible-colours="false">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isMobile from 'ismobilejs'

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

export default {
  name: 'home',
  components: {
  },
  data: function() {
    return {
      ui: {},
      isMobile: isMobile(window.navigator).phone,
      showAd1: false,
      hasVisited: false,
      verticalFlexHtml: `
      <div class="wrapper">
        <div>
          vertical aligned div
        </div>
      </div>`,
      verticalTransformHtml: `
      <div class="wrapper">
        <div class="centered">
          vertical aligned div
        </div>
      </div>`,
      verticalTableHtml: `
      <div class="wrapper">
        <div class="centered">
          vertical aligned div
        </div>
      </div>`,
      render: false
    }
  },
  computed: {

  },
  methods: {
    init() {
      this.hasVisited = this.$ls.get('hasVisitedHome')
      this.calcShowAd1()
      let foo
      if (!this.showAd1) {
        if (this.isMobile) {
          atOptions = {
            'key' : '7945d15ad340090ef9d6962d0a1dd15e',
            'format' : 'iframe',
            'height' : 50,
            'width' : 320,
            'params' : {}
          }
          foo = document.createElement('script');    
          foo.setAttribute("src","https://tablequantity.com/bd627f8395bf306cfe4e15b85c4a3531/invoke.js");
        }
        else {
          window.atOptions = {
            'key' : 'bd627f8395bf306cfe4e15b85c4a3531',
            'format' : 'iframe',
            'height' : 90,
            'width' : 728,
            'params' : {}
          };
          foo = document.createElement('script');    
          foo.setAttribute("src","https://tablequantity.com/bd627f8395bf306cfe4e15b85c4a3531/invoke.js");
        }
        this.$refs.vue_ad1.appendChild(foo);
      } else {
        this.$ls.set('hasVisitedHome', true, 3600000)
      }
    },
    escapeHtml(code) {
      return escape(code)
    },
    async calcShowAd1() {
      if (this.hasVisited) {
        this.showAd1 = false
        return
      }
      else {
        if (getRandomInt(2) == 1) {
          this.showAd1 = false
          return
        }
      }
      this.showAd1 = true
    },
  },
  created() {
    //(adsbygoogle = window.adsbygoogle || []).push({})
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="stylus">
.pre-padding {
  padding:0px!important
  box-shadow:0px 0px 20px 2px rgba(0,0,0,0.5)
}
.caniuse {
  feature {
  box-shadow:0px 0px 20px 2px rgba(0,0,0,0.5)
  }
}
</style>
